import type { ComponentProps } from 'react';
import type React from 'react';

import { cn } from '../cn';
import { type BadgeProps } from './Badge';
import BadgeContainer from './BadgeContainer';
import BadgeIcon from './BadgeIcon';
import BadgeText from './BadgeText';

export type BadgeWButtonProps = Omit<BadgeProps, 'icon' | 'dot'> & {
  onButtonClick: ComponentProps<'div'>['onClick'];
  disabled?: boolean;
  bIcon: React.JSX.Element;
} & {
  ref?: React.Ref<HTMLElement>;
};

export default function BadgeWButton({
  onButtonClick,
  rounded,
  className,
  bIcon,
  disabled,
  ...props
}: BadgeWButtonProps) {
  return (
    <BadgeContainer rounded={rounded} className={cn('group relative', className)} {...props}>
      <BadgeText
        size={props.size}
        className={cn('pr-2 transition-all group-hover:pr-3 group-hover:first:pl-1', {
          'pr-1.5 group-hover:pr-2.5 group-hover:first:pl-0.5': props.size === 'sm',
          'pr-1 group-hover:pr-1.5 group-hover:first:pl-0.5': props.size === 'xs',
        })}>
        {props.children}
      </BadgeText>
      <BadgeIcon
        icon={bIcon}
        size={props.size}
        onClick={disabled ? undefined : onButtonClick}
        type={props.type}
        className={cn('absolute right-0 opacity-0 transition-opacity group-hover:opacity-100', {
          'bg-zumthor-50 dark:bg-zumthor-300': props.type == null,
          'bg-lynch-600': props.type === 'standard',
          'bg-mantis-400': props.type === 'success',
          'bg-fair-pink-50 dark:bg-fair-pink-800': props.type === 'dangerous',
          'bg-quarter-spanish-white-200': props.type === 'warning',
        })}
      />
    </BadgeContainer>
  );
}
